import './checkbox-select.scss';
import React, { useEffect, useState } from 'react';
import { Icon } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

function CheckboxSelect({ options, title = '', onChange }) {
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [selectedLabel, setSelectedLabel] = useState([]);
	const [unSelectedOptions, setUnselectedOptions] = useState('');
	const [showAllItem, setShowAllItem] = useState(false);

	const handleOptionChange = (value, type = 'add') => {
		if (type === 'add') {
			setUnselectedOptions('')
			setSelectedOptions((prevSelectedOptions) => {
				if (prevSelectedOptions.includes(value)) {
					return prevSelectedOptions.filter((option) => option !== value);
				} else {
					return [...prevSelectedOptions, value];
				}
			});
		} else {
			setSelectedOptions((prevSelectedOptions) => {
				return prevSelectedOptions.filter((option) => option !== value);
			});
			setSelectedLabel((prevSelectedOptions) => {
				return prevSelectedOptions.filter((option) => option !== value);
			});
			setUnselectedOptions(value)
		}



	};

	const detailsSelection = () => {
		setSelectedLabel([])
		const temp = []
		Object.entries(options).map(([key, label]) => {
			selectedOptions.filter((option) => {
				if (option === key) {
					temp.push((temp.length === 0) ? ' ' + label :  ' - ' + label )
				}
			})
		});

		setSelectedLabel(temp)
	}

	useEffect(() => {
		if (unSelectedOptions !== '') {
			onChange({value: unSelectedOptions, type: 'delete'});
		} else {
			onChange({value: selectedOptions, type: 'add'});
		}
		detailsSelection()
	}, [selectedOptions])

	useEffect(() => {
		if (!showAllItem) return ;
		const handleClickOutside = (e) => {
			const clickedElement = e.target;
			const hasAllListAndShowClasses = clickedElement.classList.contains('all-list') && clickedElement.classList.contains('show');
			if (!hasAllListAndShowClasses) {
				setShowAllItem(false);
			}
		};

		const addEventListener = () => {
			document.addEventListener('click', handleClickOutside);
		};

		const removeEventListener = () => {
			document.removeEventListener('click', handleClickOutside);
		};

		addEventListener();

		return () => {
			removeEventListener();
		};
	}, [showAllItem]);

	const onHandleList = () => {
		setShowAllItem(!showAllItem)
	}

	return (
		<div className='check-box-select'>
			{title !== '' && (
				<div className='label md-label'>
					{title}
				</div>
			)}
			<div className='list-selected' onClick={onHandleList}>
				<span>{(selectedLabel.length > 0 ) ? selectedLabel : 'همه'}</span>
				<Icon component={AddIcon}/>
			</div>

			<div className={`all-list ${showAllItem ? 'show' : null}`}
				 onClick={(e)=>
				 {setShowAllItem(false)}}>
				<div className="header">
					{title}
					<Icon component={ChevronRightIcon} />
				</div>
				{Object.entries(options).map(([key, value]) => (
					<label key={key}
						   onClick={(e) => {
							   e.stopPropagation();
						   }}
						   className={selectedOptions.includes(key) ? 'active': null}>
						<input
							type="checkbox"
							value={key}
							checked={selectedOptions.includes(key)}
							onChange={(e) => {
								if (e.target.checked) {
									return handleOptionChange(key, 'add')
								} else {
									return handleOptionChange(e.target.defaultValue, 'delete')
								}
							}}
						/>
						{value}
					</label>
				))}
			</div>
		</div>
	);
}


export default CheckboxSelect;